import { ValueFormatterParams } from "ag-grid-community";
import React, { useRef, useState } from "react";
import Grid from "../../../../components/Grid";
import { ColumnDef } from "../../../../components/Grid/model/Grid";

import { useModal } from "../../../../hooks/ModalContext";
import CreateOperacaoPatioFaturamento from "./Create";
import Info from "./Info";
import { IOperacoesPatioFaturamento } from "./types/types";

const ListOperacoesPatioFaturamento: React.FC = () => {
  const [columns] = useState<ColumnDef[]>([
    {
      field: "placa_dianteira_veiculo",
      headerName: "Placa",
      filter: true,
      flex: 1,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "transportadoras.razao_social",
      fieldName: "razao_social",
      headerName: "Razão Social",
      filter: true,
      flex: 1,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "transportadoras.nome_fantasia",
      fieldName: "nome_fantasia",
      headerName: "Nome Fantasia",
      filter: true,
      flex: 1,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
  ]);
  const [selectedRow, setSelectedRow] = useState<IOperacoesPatioFaturamento>();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isView, setIsView] = useState<boolean>(false);

  const gridRef = useRef<any>(null);
  const { isModalOpen, closeModal, openModal } = useModal();

  return (
    <>
      {isModalOpen && (
        <CreateOperacaoPatioFaturamento
          isView={isView}
          isEdit={isEdit}
          selectedRow={selectedRow}
          onClear={() => {
            closeModal();
            setIsEdit(false);
          }}
          onConfirm={() => {
            closeModal();
            gridRef.current?.refresh();
          }}
        />
      )}

      {isView && (
        <Info
          data={selectedRow}
          title="Conhecer - Operações Pátio Faturamento"
          onClose={() => setIsView(!isView)}
        />
      )}

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">Faturamento</h1>
          </div>
        </div>
        <div className="flex w-full">
          <Grid
            ref={gridRef}
            columns={columns}
            filters={[]}
            pagination
            path="/listar/transportadorasVeiculos"
            onUpdate={(data: IOperacoesPatioFaturamento) => {
              setSelectedRow(data);
              setIsEdit(!isEdit);
              openModal();
            }}
            onView={(data: IOperacoesPatioFaturamento) => {
              setSelectedRow(data);
              setIsView(!isView);
            }}
            status={[]}
          />
        </div>
      </div>
    </>
  );
};

export default ListOperacoesPatioFaturamento;

